import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ComboTurma } from '../../../../core/combo-turma';
import { PlanejamentoOficina } from '../../../../core/planejamento-oficina';
import { TurmaPlanejamentoOficina } from '../../../../core/turma-planejamento-oficina';
import { Turmas } from '../../../../core/turmas';
import { DataUtilService } from "../../../../services/commons/data-util.service";
import { ToastService } from '../../../../services/toast/toast.service';
import { TurmasService } from '../../../../services/turmas/turmas.service';

@Component({
    selector: 'cadastrar-turmas-planejamento-oficina',
    templateUrl: './cadastrar-turmas-planejamento-oficina.component.html',
    styleUrls: ['./cadastrar-turmas-planejamento-oficina.component.css']
})
export class CadastrarTurmasPlanejamentoOficinaComponent implements OnInit {

    @Input() planejamentoOficina: PlanejamentoOficina;
    turmaPlanejamentoOficina: TurmaPlanejamentoOficina;
    comboTurmaSelecionado: ComboTurma;
    listaDeTurmas: Turmas[] = [];

    isAtualizar = false;
    isMostrarFuncionario = false;

    formasPagamento = [
        {tipo: 'D', descricao: 'Dinheiro'},
        {tipo: 'C', descricao: 'Cartão'},
        {tipo: 'D', descricao: 'Débito'},
        {tipo: 'F', descricao: 'Desconto em folha'},
    ];

    constructor(
        private turmaService: TurmasService,
        private dataUtilService: DataUtilService,
        private toastService: ToastService
    ) {
    }

    ngOnInit() {
        this.zerarCombos();
        this.turmaService.getAll().subscribe((turmas: Turmas[]) => {
            this.listaDeTurmas = turmas;
        });
    }


    zerarCombos() {
        this.turmaPlanejamentoOficina = new TurmaPlanejamentoOficina();
        this.turmaPlanejamentoOficina.turma = new Turmas();
        this.isMostrarFuncionario = false;
    }

    adicionar() {
        this.montarTurma(this.comboTurmaSelecionado.id);

        const turmaId = this.turmaPlanejamentoOficina?.turma?.id;
        const jaExiste = this.planejamentoOficina.turmasPlanejamentosOficinas?.some(tpo =>
            tpo?.turma?.id === turmaId
        );

        if (jaExiste) {
            this.toastService.showAlerta('Essa turma já está inclusa no planejamento de oficina.');
            return;
        }

        const turmaPlanejamentoOficina = new TurmaPlanejamentoOficina();
        Object.assign(turmaPlanejamentoOficina, this.turmaPlanejamentoOficina);
        if (!this.planejamentoOficina.turmasPlanejamentosOficinas) {
            this.planejamentoOficina.turmasPlanejamentosOficinas = [];
        }
        this.planejamentoOficina.turmasPlanejamentosOficinas.push(turmaPlanejamentoOficina);
        this.zerarCombos();
    }


    montarTurma(idTurma: number) {
        this.turmaPlanejamentoOficina.turma = _.cloneDeep(_.find(this.listaDeTurmas, (m: Turmas) => m.id === idTurma));
    }

    atualizar() {
        const turmaId = this.turmaPlanejamentoOficina?.turma?.id;

        const jaExiste = this.planejamentoOficina.turmasPlanejamentosOficinas?.some(tpo =>
            tpo?.turma?.id === turmaId && tpo?.id !== this.turmaPlanejamentoOficina.id
        );

        if (jaExiste) {
            this.toastService.showAlerta('Essa turma já está inclusa no planejamento de oficina.');
            return;
        }

        const index = this.planejamentoOficina.turmasPlanejamentosOficinas.indexOf(this.planejamentoOficina.turmasPlanejamentosOficinas.find(col => col.id === this.turmaPlanejamentoOficina.id));
        this.planejamentoOficina.turmasPlanejamentosOficinas.splice(index, 1, this.turmaPlanejamentoOficina);
        this.isAtualizar = false;
        this.zerarCombos();
    }

    atualizarTurma(turmaPlanejamentoOficina: TurmaPlanejamentoOficina) {
        if (turmaPlanejamentoOficina && turmaPlanejamentoOficina.turma && turmaPlanejamentoOficina.turma.id) {
            this.montarComboTurma(turmaPlanejamentoOficina.turma.id);
        }
        this.isAtualizar = true;
        this.turmaPlanejamentoOficina = turmaPlanejamentoOficina;
    }

    cancelar() {
        this.zerarCombos();
        this.isAtualizar = false;
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    onValorChangeMaterial(registro: any) {
        if (registro && registro.id) {
            this.montarTurma(registro.id);
            this.montarComboTurma(registro.id);
        }
    }

    montarComboTurma(id: number) {
        this.listaDeTurmas.forEach(m => {
            if (m.id == id) {
                this.comboTurmaSelecionado = { id: m.id, descricao: m.descricao };
            }
        });
    }

}
